import { useNavigate } from 'react-router-dom';

import { NBA_HOME } from '@sorare/core/src/constants/__generated__/routes';
import { useIsMobileApp } from '@sorare/core/src/hooks/useIsMobileApp';

import { QuickPlayTutorialDialog } from '@sorare/gameplay/src/components/quickPlay/QuickPlayTutorialDialog';

const QuickPlayTutorialPage = () => {
  const { isIosApp, postMessage } = useIsMobileApp();
  const navigate = useNavigate();

  return (
    <QuickPlayTutorialDialog
      open
      onClose={() => {
        if (isIosApp) {
          postMessage('closeCurrentWebview');
        } else {
          navigate(NBA_HOME);
        }
      }}
    />
  );
};
export default QuickPlayTutorialPage;
